import { supabase } from './supabase';

const DEVICE_KEY = 'jonnys-pit-crew-device-id';
const UNLOCK_PREFIX = 'jonnys-pit-crew-pin-unlocked:';

export function getQuickPinDeviceId() {
  let deviceId = window.localStorage.getItem(DEVICE_KEY);
  if (!deviceId) {
    deviceId = crypto.randomUUID();
    window.localStorage.setItem(DEVICE_KEY, deviceId);
  }
  return deviceId;
}

export function quickPinDeviceLabel() {
  const platform = navigator.userAgentData?.platform || navigator.platform || 'Browser';
  const mobile = navigator.userAgentData?.mobile || /Android|iPhone|iPad|Mobile/i.test(navigator.userAgent);
  return `${mobile ? 'Mobile' : 'Computer'} · ${platform}`.slice(0, 120);
}

function unlockKey(userId) {
  return `${UNLOCK_PREFIX}${userId}:${getQuickPinDeviceId()}`;
}

export function isQuickPinUnlocked(userId) {
  return window.sessionStorage.getItem(unlockKey(userId)) === 'yes';
}

export function markQuickPinUnlocked(userId) {
  window.sessionStorage.setItem(unlockKey(userId), 'yes');
}

export function clearQuickPinUnlock(userId) {
  if (!userId) return;
  window.sessionStorage.removeItem(unlockKey(userId));
}

export async function getQuickPinStatus() {
  if (!supabase) return { enabled: false };
  const { data, error } = await supabase.rpc('quick_pin_status', {
    p_device_id: getQuickPinDeviceId(),
  });
  if (error) throw error;
  return data || { enabled: false };
}

export async function setQuickPin(pin) {
  if (!supabase) throw new Error('Supabase is not configured.');
  const { data, error } = await supabase.rpc('set_quick_pin', {
    p_device_id: getQuickPinDeviceId(),
    p_pin: pin,
    p_device_label: quickPinDeviceLabel(),
  });
  if (error) throw error;
  return data;
}

export async function verifyQuickPin(pin) {
  if (!supabase) throw new Error('Supabase is not configured.');
  const { data, error } = await supabase.rpc('verify_quick_pin', {
    p_device_id: getQuickPinDeviceId(),
    p_pin: pin,
  });
  if (error) throw error;
  return data;
}

export async function removeQuickPin() {
  if (!supabase) return;
  const { error } = await supabase.rpc('remove_quick_pin', {
    p_device_id: getQuickPinDeviceId(),
  });
  if (error) throw error;
}
